import styled from 'styled-components';

export const Container = styled.aside`
  width: 21vw;
  max-width: 215px ;
  height: 435px;
  border: 1px solid var(--light-gray);
  opacity: 1;
  
`;

export const HeaderBox = styled.div`
width: 100%;
height: 55px;
background: #E7E7E7 0% 0% no-repeat padding-box;
display: flex;
justify-content: space-evenly;
align-items: center;
h3{
  margin: 0;
  font-size: 16px;
  margin-right: 35px;
}

`
export const ContainerBox = styled.div`

display: flex;
flex-direction: column;
margin: 10px;
p{
  margin: 0;
  width: 160px;
}
p:first-child{
  font-size: 12px;
  text-align: left;
  color: #161615;
font-weight: 600;
margin-bottom: 5px;
}
`
